import { NormalGet, NormalDelete, NormalPost, NormalPut } from '@/js/request';

const modelName = process.env.VUE_APP_APIPrefix_bu || '';

export const SystemHealthCheckGet = (data) => {
  return NormalGet(modelName, '/health_check', data);
};

export const BuUserGetList = (data) => {
  return NormalGet(modelName, '/user', data);
};
export const BuUserCreate = (data) => {
  return NormalPost(modelName, '/user', data);
};
export const BuUserUpdate = (data) => {
  return NormalPut(modelName, '/user', data);
};
export const BuUserDelete = (data) => {
  return NormalDelete(modelName, `/user?${data}`, data);
};
export const BuUserSearchDropDownGetList = (data) => {
  return NormalGet(modelName, '/user/dropdown', data);
};
export const BuUserCheckList = (data) => {
  return NormalPost(modelName, '/user/dropdown', data);
}; // 連動BU判斷 20230815

/**
 * 取得使用者群組設定列表
 * @param {*} data
 * @returns
 */
export const BuRoleGetList = (data) => {
  return NormalGet(modelName, '/role', data);
};
export const BuRoleCreate = (data) => {
  return NormalPost(modelName, '/role', data);
};
export const BuRoleUpdate = (data) => {
  return NormalPut(modelName, '/role', data);
};
export const BuRoleDelete = (data) => {
  return NormalDelete(modelName, '/role', data);
};
export const BuRoleSearchDropDownGetList = (data) => {
  return NormalGet(modelName, '/role/dropdown', data);
};

export const BuRolePermissionGetList = (data) => {
  return NormalGet(modelName, '/rolePermission', data);
};
export const BuRolePermissionCreate = (data) => {
  return NormalPost(modelName, '/rolePermission', data);
};
export const BuRolePermissionUpdate = (data) => {
  return NormalPut(modelName, '/rolePermission', data);
};

export const BuUserRoleGetList = (data) => {
  return NormalGet(modelName, '/buUserRoleSetting', data);
};
export const BuUserRoleCreate = (data) => {
  return NormalPost(modelName, '/buUserRoleSetting', data);
};
export const BuUserRoleUpdate = (data) => {
  return NormalPut(modelName, '/buUserRoleSetting', data);
};

export const BuUserPermissionGetList = (data) => {
  return NormalGet(modelName, '/buUserPermission', data);
};
export const BuUserPermissionUpdate = (data) => {
  return NormalPut(modelName, '/buUserPermission', data);
};

export const BuControlRolePermissionGetList = (data) => {
  return NormalGet(modelName, '/control/rolePermission', data);
};
export const BuControlRolePermissionCreate = (data) => {
  return NormalPost(modelName, '/control/rolePermission', data);
};

export const BuControlUserPermissionGetList = (data) => {
  return NormalGet(modelName, '/control/userPermission', data);
};
export const BuControlUserPermissionCreate = (data) => {
  return NormalPost(modelName, '/control/userPermission', data);
};

// 新增按鈕判斷
export const BuGetAddBtnPermission = (data) => {
  return NormalGet(modelName, '/create/button', data);
};

// 群組編輯成員
export const BuRoleGetUserSetting = (data) => {
  return NormalGet(modelName, '/buRoleUserSetting', data);
};
export const BuRoleUserSettingUpdate = (data) => {
  return NormalPut(modelName, '/buRoleUserSetting', data);
};

// 群組其他權限
export const BuRoleGetOther = (data) => {
  return NormalGet(modelName, '/role/otherPermission', data);
};
export const BuRolePutOther = (data) => {
  return NormalPut(modelName, '/role/otherPermission', data);
};

//
// 人員其他權限
//

/** 取得BU使用者其他設定 */
export const BuUserGetOther = (data) => {
  return NormalGet(modelName, '/user/otherPermission', data);
};
export const BuUserPutOther = (data) => {
  return NormalPut(modelName, '/user/otherPermission', data);
};
